import { useEffect, useState } from 'react'
import { formatCallClock } from '@common/helpers/arcVoice'
import { IArcVoiceCallSnapshot } from '../helpers/arcVoice/arcVoiceCall'

const TICK_MS = 500

/**
 * A running clock, `6:32`: `carriedMs` already talked, plus the time since `liveSince`
 * (epoch ms). Ticks only while `liveSince` is set; null and nothing carried reads empty.
 */
export const useLiveClock = (liveSince: number | null, carriedMs = 0): string => {
  const [now, setNow] = useState(() => Date.now())
  const isLive = liveSince !== null

  useEffect(() => {
    if (!isLive) return undefined
    const timer = setInterval(() => setNow(Date.now()), TICK_MS)
    return () => clearInterval(timer)
  }, [isLive])

  return formatCallClock(carriedMs + (isLive ? Math.max(now, liveSince) - liveSince : 0))
}

/** The Arc call's clock, ticking only while the line is live. */
const useCallClock = (snapshot: IArcVoiceCallSnapshot | null): string => {
  const clock = useLiveClock(snapshot?.liveSince ?? null, snapshot?.activeMs ?? 0)
  return snapshot ? clock : ''
}

export default useCallClock
